'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const React = require('react');
const react = require('@emotion/react');
const clsx = require('clsx');
const components_forms_Input_Input = require('../Input/Input.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const clsx__default = /*#__PURE__*/_interopDefault(clsx);

const textInput = "_text-input_o0wi4_1";
const styles = {
	textInput: textInput
};

const TextInput = React.forwardRef((_a, ref) => {
  var { defaultValue, isMultiline = false, type = "text", isFullWidth = false, size = "medium", borderRadius = "medium", className } = _a, otherProps = tslib_es6.__rest(_a, ["defaultValue", "isMultiline", "type", "isFullWidth", "size", "borderRadius", "className"]);
  const props = Object.assign({
    isMultiline,
    type,
    isFullWidth,
    size,
    borderRadius
  }, otherProps);
  const Tag = props.isMultiline ? "textarea" : "input";
  return react.jsx(components_forms_Input_Input.Input, Object.assign({}, props, { renderIconAfter: props.isMultiline ? void 0 : props.renderIconAfter, renderIconBefore: props.isMultiline ? void 0 : props.renderIconBefore }), (inputProps) => react.jsx(Tag, Object.assign({}, inputProps, { autoCapitalize: props.autoCapitalize, autoCorrect: props.autoCorrect, className: clsx__default.default(styles.textInput, className), css: inputProps.css, defaultValue, inputMode: props.inputMode, ref, rows: props.isMultiline ? props.rows : void 0, spellCheck: props.spellCheck, type: !props.isMultiline ? props.type : void 0, value: inputProps.value, onChange: inputProps.onChange, "data-zds": true, "data-multiline": isMultiline, "data-fullwidth": isFullWidth, "data-size": size, "data-resize": props.resize })));
});

exports.TextInput = TextInput;
//# sourceMappingURL=TextInput.cjs.js.map
